import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';
import { possibleMltOptions } from 'redux/reducers/fluxAutomaticControlPanelReducer';
import UnicenarioDesktop from 'components/Flux/Automatic/Unicenario/Desktop';
import UnicenarioMobile from 'components/Flux/Automatic/Unicenario/Mobile';
import useFluxAutomaticFilterSelector from 'utils/hooks/flux/automatic/filterSelector';
import useIsMobile from 'utils/hooks/useIsMobile';
import './index.scss';

export default function Unicenario() {
  const isMobile = useIsMobile();
  const { setMltOption } = useFluxAutomaticFilterSelector();

  useEffect(() => {
    store.dispatch(setCurrentTab('unicenario'));
    setMltOption(possibleMltOptions[0]); // %MLT
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isMobile) {
    return <UnicenarioMobile />;
  }

  return <UnicenarioDesktop />;
}
